import { envDefaults } from './envDefaults';

const dev = {
  apiUrl: envDefaults.apiUrl,

  auth: {
    signin: '/rest-auth/login',
    me: '/rest-auth/me',
    logout: '/rest-auth/logout',
  },


  master: {
    skills: '/tables/all-skills',
    pronouns: '/tables/all-pronouns',
    headlines: '/tables/all-headlines',
    colleges: '/tables/all-colleges',
    cities: '/tables/all-cities/:id',
    regions: '/tables/all-regions/:id',
    countries: '/tables/all-countries',
    companies: '/tables/all-companies',
    courses: '/tables/all-courses',
    courseTypes: '/tables/all-course-types',

    company: '/company',
  },

  bookmarks: {
    getBookmark: '/user-bookmarks/saved',

    jobBookmark: '/user-bookmarks/bookmark-job',
    jobBookmarks: '/user-bookmarks/bookmark-jobs',

    contact: '/contact',
    allAdminContact: '/contact/admin/all',
    userContacts: '/contact/user/all',

    exportUserContacts: '/contact/export',
    exportAllAdminContacts: '/contact/admin/export',
    exportSelectedUserContacts: '/contact/export/selected',

    company: '/company',
  },

  organisation: {
    organisation: '/organisation/',
    organisationUser: '/organisation/user',
    getOrganisationUsers: '/organisation/users',
  },

  category: {
    category: '/category',
  },

  microsoft: {
    emailThreads: (id) => `/microsoft/email-threads/${id}`,
    checkAuth: '/microsoft/check-auth',
  },
};

const config = dev;

export default {
  ...config,
};
